import { useCallback, useEffect, useState } from "react";
import { RefreshCw, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { AdminPageHeader } from "./components/AdminUi";

const API = process.env.REACT_APP_BACKEND_URL;

export default function DemoAccountAdminModule() {
  const token = localStorage.getItem("super_admin_token");
  const [status, setStatus] = useState(null);
  const [confirmation, setConfirmation] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    const response = await fetch(`${API}/api/admin/demo-account/status`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const body = await response.json();
    if (!response.ok) throw new Error(body.detail || "Impossibile caricare l'account Demo");
    setStatus(body);
  }, [token]);

  useEffect(() => { load().catch((error) => toast.error(error.message)); }, [load]);

  const reset = async () => {
    if (confirmation.toUpperCase() !== "DEMO") return;
    setLoading(true);
    try {
      const response = await fetch(`${API}/api/admin/demo-account/reset`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ confirmation }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.detail || "Ripristino non riuscito");
      toast.success("Account Demo ripristinato");
      setConfirmation("");
      await load();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <AdminPageHeader title="Account Demo" description="Dati fittizi della fiera, isolati dai tenant reali." />
      {!status ? <p>Caricamento…</p> : !status.configured ? (
        <Card><CardContent className="p-6 text-amber-800">Account Demo non configurato: {status.reason}</CardContent></Card>
      ) : <>
        <Card><CardContent className="p-6 space-y-3">
          <h2 className="font-semibold">Credenziali demo</h2>
          {status.credentials.map((item) => <div key={item.portal} className="text-sm"><b>{item.portal}</b>: {item.email} — {item.password}</div>)}
          <p className="text-sm text-slate-600">Ultimo ripristino: {status.last_reset_at ? new Date(status.last_reset_at).toLocaleString("it-IT") : "mai"}</p>
        </CardContent></Card>
        <Card className="border-red-200"><CardContent className="p-6 space-y-4">
          <div className="flex gap-2 text-red-800"><ShieldAlert /><div><h2 className="font-semibold">Ripristina dati Demo</h2><p className="text-sm">Cancella solo documenti associati all'organizzazione Demo verificata e li ricrea.</p></div></div>
          <p className="text-sm">Documenti da ricreare: {status.preview?.total ?? 0}</p>
          <div className="flex gap-2 max-w-md"><Input value={confirmation} onChange={(e) => setConfirmation(e.target.value)} placeholder='Digita "DEMO" per confermare' /><Button variant="destructive" disabled={confirmation.toUpperCase() !== "DEMO" || loading} onClick={reset}>{loading ? <RefreshCw className="animate-spin" /> : "Ripristina"}</Button></div>
        </CardContent></Card>
      </>}
    </div>
  );
}
